// ------ Actions ------

const SELECT_COUNTRY = "browseHero/SELECT_COUNTRY";
const DESELECT_COUNTRY = "browseHero/DESELECT_COUNTRY";
const SELECT_CATEGORY = "browseHero/SELECT_CATEGORY";
const DESELECT_CATEGORY = "browseHero/DESELECT_CATEGORY";
const SELECT_ALL_CATEGORY = "browseHero/SELECT_ALL_CATEGORY";
const SELECT_ALL_COUNTRY = "browseHero/SELECT_ALL_COUNTRY";
const SELECT_ORDERBY = "browseHero/SELECT_ORDERBY";
const SELECT_ALL_ORDERBY = "browseHero/SELECT_ALL_ORDERBY";

// ------ Reducer ------

const initialState = {
  selectedCountries: [],
  selectedCategories: window.Chuffed.selectedCategories,
  selectedOrderBy: [],
};

const rootReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SELECT_ORDERBY:
      return {
        ...state,
        selectedOrderBy: [
          action.orderBy,
        ],
      };
    case SELECT_ALL_ORDERBY:
      return {
        ...state,
        selectedOrderBy: [],
      };
    case SELECT_COUNTRY:
      return {
        ...state,
        selectedCountries: [
          ...state.selectedCountries,
          action.country,
        ],
      };
    case SELECT_ALL_COUNTRY:
      return {
        ...state,
        selectedCountries: [],
      };
    case DESELECT_COUNTRY:
      return {
        ...state,
        selectedCountries: [
          ...state.selectedCountries.filter((c) => c !== action.country),
        ],
      };
    case SELECT_CATEGORY:
      return {
        ...state,
        selectedCategories: [
          ...state.selectedCategories,
          action.category,
        ],
      };
    case SELECT_ALL_CATEGORY:
      return {
        ...state,
        selectedCategories: [],
      };
    case DESELECT_CATEGORY:
      return {
        ...state,
        selectedCategories: [
          ...state.selectedCategories.filter((c) => c !== action.category),
        ],
      };
    default:
      return state;
  }
};
export default rootReducer;

// ------ Synchronous Actions ------

export const selectCountry = (country) => ({
  type: SELECT_COUNTRY,
  country,
});

export const selectAllCountries = () => ({
  type: SELECT_ALL_COUNTRY,
});

export const deselectCountry = (country) => ({
  type: DESELECT_COUNTRY,
  country,
});

export const selectCategory = (category) => ({
  type: SELECT_CATEGORY,
  category,
});

export const selectAllCategories = () => ({
  type: SELECT_ALL_CATEGORY,
});

export const deselectCategory = (category) => ({
  type: DESELECT_CATEGORY,
  category,
});

export const selectOrderBy = (orderBy) => ({
  type: SELECT_ORDERBY,
  orderBy,
});

export const selectAllOrderBy = () => ({
  type: SELECT_ALL_ORDERBY,
});
